import { useEffect, useState } from "react";

const useTableHeight = (tableRef, defaultLimit = 1) => {
  const [limit, setLimit] = useState(defaultLimit);
  useEffect(() => {
    const calculateLimit = () => {
      if (!tableRef.current) return;

      const containerHeight = tableRef?.current?.clientHeight;

      const width = window.innerWidth;

      let rowHeight = 45;

      if (width < 1600) {
        rowHeight = 37;
      }

      const visibleRows = Math.floor(containerHeight / rowHeight);
      const newLimit = visibleRows > 0 ? visibleRows : 20;

      setLimit((prevLimit) => (prevLimit !== newLimit ? newLimit : prevLimit));
    };

    calculateLimit();
    window.addEventListener("resize", calculateLimit);
    return () => window.removeEventListener("resize", calculateLimit);
  }, [tableRef]);

  return limit;
};

export default useTableHeight;
